import { Product } from 'BrokerTsLib/src/enums'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation } from 'react-query'
import { baseUrl } from '.'
import { useApp } from './useApp'

const apiVehicleUrl = import.meta.env.VITE_INSURANCEDRAFT_VEHICLE_API

export const useCreateInsuranceParamsFromDraft = () => {
  const { product } = useApp()

  let url: string | undefined = ''

  switch (product) {
    case Product.VehicleInsurance:
    case Product.VehicleLeasingInsurance:
    case Product.FleetInsurance:  
      url = apiVehicleUrl; break
    default: break
  }

  return useMutation((draft?: string) =>
    apiClient.post<number>(`${baseUrl}/${url}/CreateInsuranceParamsFromDraft`, undefined, { params: { draft } })
  , {})
}